module.exports = require('../dist/selectors/personal-loans');
